var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCameraAlt = function SvgCameraAlt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.6667C11.4728 12.6667 12.6667 11.4728 12.6667 10C12.6667 8.52725 11.4728 7.33334 10 7.33334C8.52725 7.33334 7.33334 8.52725 7.33334 10C7.33334 11.4728 8.52725 12.6667 10 12.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49999 1.66666L5.97499 3.33332H3.33332C2.41666 3.33332 1.66666 4.08332 1.66666 4.99999V15C1.66666 15.9167 2.41666 16.6667 3.33332 16.6667H16.6667C17.5833 16.6667 18.3333 15.9167 18.3333 15V4.99999C18.3333 4.08332 17.5833 3.33332 16.6667 3.33332H14.025L12.5 1.66666H7.49999ZM9.99999 14.1667C7.69999 14.1667 5.83332 12.3 5.83332 9.99999C5.83332 7.69999 7.69999 5.83332 9.99999 5.83332C12.3 5.83332 14.1667 7.69999 14.1667 9.99999C14.1667 12.3 12.3 14.1667 9.99999 14.1667Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCameraAlt);
export { ForwardRef as ReactComponent };